/**
 * Adds the axiom typeRef property to a functional component, and applies the correct TS typing. Needed to make findComponent work.
 * See 'forwardRefWothAxiomType' if you need ref forwarding
 * @param component The functional component that you wish to add the typeRef property to.
 * @param typeRef the Axiom tpyeref value (usually the name of the component)
 * @returns The component with the typeRef applied
 */
export default function withAxType(component, typeRef) {
  const componentWithType = component;
  componentWithType.typeRef = typeRef;
  return componentWithType;
}